var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "256px",
    width: "256px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-48.92 -48.92 587.05 587.05",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48.92,
    y: -48.92,
    width: 587.05,
    height: 587.05,
    rx: 0,
    fill: "#000000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.6,199.719c-13.4,0-24.2,10.8-24.2,24.2v10.8H8.1c-4.5,0-8.1,3.6-8.1,8.1v30.3c0,4.5,3.6,8.1,8.1,8.1h7.3v9.3 c0,13.4,10.8,24.2,24.2,24.2h6l27.7,92.2l4.2-1l14-3.3l4.2-1l-11.2-86.9h22.4v-10.1c29.4,4.8,78.1,17.2,112,49.4 c0.4,6,5.6,10.7,11.9,9.9c5.5-0.6,9.4-5.6,9.4-11.1v-62.2c13.6-5.1,23.4-18.2,23.4-33.6s-9.7-28.5-23.4-33.6v-61.8 c0-5.5-3.9-10.5-9.4-11.1c-6.2-0.7-11.5,3.9-11.9,9.9c-33.9,32.2-82.6,44.7-112,49.4v-10.1L39.6,199.719L39.6,199.719z M81.3,289.219H41v-63.9h40.3V289.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.9,114.619c-43.1-43.1-113.1-43.1-156.2,0c-41.5,41.5-43.1,107.9-4.7,151.3l1.1,0.9c-4.2,9-11.3,20.1-22.7,25.7 c-3.8,1.8-2.9,7.5,1.2,8.1c12.5,1.9,30.3-0.2,47-12.8l0.2,0.2c42.3,24.9,97.7,19.2,134-17.2 C500,227.719,500,157.719,456.9,114.619z M404.5,228.019c-3.9,4.7-9,7.9-14.9,9.6c-2.6,0.7-3.7,2.1-3.6,4.8c0.1,2.6,0,5.3,0,7.9 c0,2.4-1.2,3.6-3.5,3.7c-2.8,0.1-5.7,0.1-8.5,0c-2.5,0-3.7-1.5-3.7-3.9c0-1.9,0-3.9-0.1-5.8c0-4.3-0.2-4.4-4.3-5.1 c-5.2-0.8-10.4-2-15.2-4.3c-3.8-1.8-4.2-2.8-3.1-6.7c0.8-2.9,1.6-5.9,2.5-8.8c1.1-3.4,2-3.8,5.1-2.2c5.3,2.8,10.9,4.3,16.8,5 c3.8,0.5,7.5,0.1,11-1.5c6.6-2.9,7.6-10.5,2-15.1c-1.9-1.6-4-2.7-6.3-3.7c-5.8-2.5-11.8-4.5-17.2-7.7 c-8.8-5.3-14.4-12.5-13.8-23.3c0.7-12.2,7.6-19.7,18.7-23.8c4.6-1.7,4.6-1.6,4.6-6.4c0-1.6,0-3.3,0-4.9c0.1-3.6,0.7-4.2,4.3-4.3 c1.1,0,2.2,0,3.4,0c7.7,0,7.7,0,7.7,7.7c0,5.4,0,5.5,5.4,6.3c4.1,0.6,8.1,1.9,11.9,3.6c2.1,0.9,2.9,2.4,2.3,4.6 c-1,3.3-1.9,6.7-2.9,9.9c-1,3.1-2,3.6-5,2.1c-6-2.9-12.3-4.1-18.9-3.7c-1.7,0.1-3.4,0.3-5,1c-5.7,2.5-6.7,8.8-1.8,12.7 c2.5,2,5.3,3.4,8.2,4.6c5.1,2.1,10.2,4.1,15,6.8C411.1,195.619,415.3,214.919,404.5,228.019z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.8cd8d5d95df3b9ee9945766c8449a959.svg";
export { ForwardRef as ReactComponent };